import { useTranslation } from 'react-i18next';

type ActivitySearchProps = {
  value: string;
  onChange: (value: string) => void;
};

export function ActivitySearch({ value, onChange }: ActivitySearchProps) {
  const { t } = useTranslation('overview');
  return (
    <input
      type="search"
      value={value}
      onChange={(event) => onChange(event.target.value)}
      placeholder={t('activityPage.searchPlaceholder')}
      aria-label={t('activityPage.searchLabel')}
      className="w-full max-w-[320px] rounded-[10px] border px-3.5 py-[11px] text-sm"
      style={{
        color: 'var(--gs-ink)',
        background: 'var(--gs-field)',
        borderColor: 'var(--gs-line)',
        fontFamily: 'inherit',
      }}
    />
  );
}
